<template>
  <div class="stored-images-container">
    <small v-if="errorMessage" class="error-label">{{errorMessage}}</small>
    <template v-if="!errorMessage && storedMms">
      <stored-image
          v-for="image in storedMms"
          :key="image.id"
          :image="image"
          :currentMms="currentMms"
          :defaultStateDisclaimer="defaultStateDisclaimer"
          :currentIsDisclaimer="currentMmsIsProbablyDisclaimer"
          @imageClicked="processClick"></stored-image>
    </template>
  </div>
</template>

<script>
  import AxiosMixin from '../../mixins/AxiosMixin'
  import StoredImage from './StoredImage'

  export default {
    props: {
      baseUrl: {
        default: '/api/v3/attachments',
        type: String
      },
      currentMms: Object,
      messageId: [Number, String],
      messageType: String,
    },

    name: 'StoredImagesContainer',

    components: {
      StoredImage,
    },

    mixins: [AxiosMixin],

    data() {
      return {
        defaultStateDisclaimer: null,
        errorMessage: null,
        storedMms: null,
      }
    },

    methods: {
      adviseLoading(isLoading) {
        this.$emit('adviseLoading', isLoading)
      },

      afterGetStoredMms(data) {
        if (data) {
          this.storedMms = data.stored_mms
          this.defaultStateDisclaimer = data.default_state_disclaimer
          this.currentMms ? this.sortCurrentMmsToFirst() : this.storedLoading = false
          if (this.defaultStateDisclaimer && !this.currentMmsIsProbablyDisclaimer) { this.insertDefaultStateDisclaimer() }
          this.errorMessage = null
        } else {
          this.errorMessage = 'issue loading previously added images'
        }
        this.adviseLoading(false)
      },

      afterUpdateMms(data) {
        const errors = data?.errors,
          noErrors = errors ? Object.keys(errors).length < 1 : true

        if (data && noErrors) {
          this.$emit('getAttachedMedia')
          this.errorMessage = null
        } else {
          this.errorMessage = errors ? `issue updating image. ${errors}` : 'issue updating image'
          this.adviseLoading(false)
        }
      },

      getStoredMms() {
        this.adviseLoading(true)
        const url = `${this.baseUrl}/stored_mms?owner_type=${this.messageType}`
        this.axiosMethod({url, onSuccess: this.afterGetStoredMms, onError: this.setLoadError})
      },

      insertDefaultStateDisclaimer() {
        let storedMmsCopy = this.storedMms
        const storedDisclaimers = storedMmsCopy.filter((mms) => { return mms.file_name == this.defaultStateDisclaimer.file_name }),
          disclaimerIncluded = storedDisclaimers.length > 0,
          currentDisclaimerIndex = disclaimerIncluded ? storedMmsCopy.map(mms => { return mms.id}).indexOf(storedDisclaimers[0].id) : null

        if (disclaimerIncluded) { storedMmsCopy.splice(currentDisclaimerIndex, 1) }
        storedMmsCopy.unshift(this.defaultStateDisclaimer)
        if (storedMmsCopy.length > 12) { storedMmsCopy.pop() }
        this.storedMms = storedMmsCopy
      },

      processClick(file, type) {
        if (type === 'preview') {
          this.$emit('previewImage', file, true)
        } else {
          const isRemoveType = type === 'remove',
              id = isRemoveType ? file.uuid : file.id
          this.updateMms(id, isRemoveType)
        }
      },

      setLoadError(error) {
        this.errorMessage = `issue loading previously added images ${error}`
        this.adviseLoading(false)
      },

      setUpdateError(error) {
        this.errorMessage = `issue updating image. ${error}`
        this.adviseLoading(false)
      },

      sortCurrentMmsToFirst() {
        const isCurrentInStored = this.storedMms.filter((mms) => { return mms.id == this.currentMms.id }).length > 0,
          currentImageIndex = this.storedMms.map(mms => { return mms.id}).indexOf(this.currentMms.id),
          currentImage = this.storedMms.splice(currentImageIndex, 1)
        this.storedMms.unshift(currentImage[0])
        this.adviseLoading(false)
      },

      updateMms(id, isRemoveType) {
        this.adviseLoading(true)
        const deleteUrl = `/api/v3/attachments/${id}`,
          setUrl = `${this.baseUrl}/attach_stored_image?owner_type=${this.messageType}&owner_id=${this.messageId}&stored_image_id=${id}`,
          url = isRemoveType ? deleteUrl : setUrl,
          methodType = isRemoveType ? 'delete' : 'patch'
        this.axiosMethod({methodType, url, onSuccess: this.afterUpdateMms, onError: this.setUpdateError})
      },
    },

    created() {
      this.getStoredMms()
    },

    computed: {
      currentMmsIsProbablyDisclaimer: function () {
        if (this.currentMms && this.defaultStateDisclaimer) {
          const sameFileName = this.currentMms.file_name === this.defaultStateDisclaimer.file_name,
            sameFileSize = this.currentMms.file_size === this.defaultStateDisclaimer.file_size
          return sameFileName && sameFileSize
        }
      },
    },

    watch: {
      currentMms: function () {
        this.getStoredMms()
      },

      errorMessage: function () {
        this.$emit('setMmsErrorMessage', this.errorMessage)
      },
    },
  }
</script>
